import { AMOBILE_BANK_ID, OZON_BANK_ID, SBER_BANK_ID, IDRAM_BANK, YANDEX_BANK_ID, WILDBERRIES_BANK_ID } from '@/entities/banks'
import { PaymentRequisiteToType } from '@/entities/paymentRequisit/model/paymentreq.types'
import { formatBankAccount, formatCardNumber, formatPhoneNumber } from '@/features/requisites/model'

// Типы реквизитов и их характеристики
export type RequisiteTypeConfig = {
  type: PaymentRequisiteToType
  formatFunc: (value: string) => { formatted: string; cleaned: string }
  validateFunc: (value: string) => string | undefined
  icon: string // имя компонента иконки
  placeholder: string
  label: string
}

// Конфигурация для каждого типа реквизита
export const REQUISITE_TYPES: Record<string, RequisiteTypeConfig> = {
  [PaymentRequisiteToType.CardNumber]: {
    type: PaymentRequisiteToType.CardNumber,
    formatFunc: formatCardNumber,
    validateFunc: (value: string) => {
      const cleaned = value.replace(/\D/g, '')
      return cleaned.length > 0 && cleaned.length < 16 ? 'Введите 16 цифр номера карты' : undefined
    },
    icon: 'CardIcon',
    placeholder: '0000 0000 0000 0000',
    label: 'Номер карты',
  },
  [PaymentRequisiteToType.SbpPhoneNumber]: {
    type: PaymentRequisiteToType.SbpPhoneNumber,
    formatFunc: formatPhoneNumber,
    validateFunc: (value: string) => {
      const cleaned = value.replace(/\D/g, '')
      return cleaned.length > 1 && cleaned.length < 11 ? 'Введите полный номер телефона' : undefined
    },
    icon: 'SimCardIcon',
    placeholder: '+7 xxx xxx-xx-xx',
    label: 'Номер телефона',
  },
  [PaymentRequisiteToType.AccountNumber]: {
    type: PaymentRequisiteToType.AccountNumber,
    formatFunc: formatBankAccount,
    validateFunc: (value: string) => {
      const cleaned = value.replace(/\D/g, '')
      return cleaned.length > 0 && cleaned.length < 20 ? 'Введите 20 цифр' : undefined
    },
    icon: 'AccountIcon',
    placeholder: '00000 000 0 0000 0000000',
    label: 'Номер счета',
  },
  [PaymentRequisiteToType.SbpPaymentLink]: {
    type: PaymentRequisiteToType.SbpPaymentLink,
    formatFunc: (value: string) => ({ formatted: value, cleaned: value }),
    validateFunc: () => undefined,
    icon: 'LinkIcon',
    placeholder: 'Введите ссылку',
    label: 'Озон чаевые',
  },
}

// Конфигурация реквизитов для разных типов банков
export const BANK_REQUISITE_CONFIG: Record<
  string,
  {
    sbp: PaymentRequisiteToType
    account?: PaymentRequisiteToType
    card?: PaymentRequisiteToType
    sbpLink?: PaymentRequisiteToType
  }
> = {
  [SBER_BANK_ID]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
    account: PaymentRequisiteToType.AccountNumber,
    card: PaymentRequisiteToType.CardNumber,
  },
  [AMOBILE_BANK_ID]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
    card: PaymentRequisiteToType.CardNumber,
  },
  [OZON_BANK_ID]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
    sbpLink: PaymentRequisiteToType.SbpPaymentLink,
  },
  [YANDEX_BANK_ID]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
  },
  [WILDBERRIES_BANK_ID]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
  },
  [IDRAM_BANK]: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
    card: PaymentRequisiteToType.CardNumber,
  },
  default: {
    sbp: PaymentRequisiteToType.SbpPhoneNumber,
    card: PaymentRequisiteToType.CardNumber,
  },
}
